import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { REGEX } from 'src/app/constants/regex';
import { HttpService, UtilityFlightService, UtilityService } from 'src/app/services';
import { CustomValidations } from 'src/custom-validations';
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-corporate-register',
  templateUrl: './corporate-register.component.html',
  styleUrls: ['./corporate-register.component.scss'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class CorporateRegisterComponent implements OnInit {
  @ViewChild('fileUpload', { static: false })
  fileUpload!: ElementRef<HTMLInputElement>;
  selectedFileName: any;
  country_APIs: any;
  RegisterCoporate: FormGroup;
  registerTypeControl = new FormControl(1, Validators.required);
  typeBusinessSelect = new FormControl('', Validators.required);
  govtApprovedIdSelect = new FormControl('', Validators.required);
  govtApprovedId = new FormControl('', Validators.required);
  vatGstCertificate = new FormControl('', Validators.required);
  salutationSelect = new FormControl(0, Validators.required);
  firstName = new FormControl('', Validators.required);
  middleName = new FormControl('');
  lastName = new FormControl('', Validators.required);
  dateOfBirth = new FormControl('');
  aadharCardNumber = new FormControl('', Validators.required);
  companyName = new FormControl('', Validators.required);
  registeredAddress = new FormControl('', Validators.required);
  registeredCity = new FormControl('', Validators.required);
  registeredState = new FormControl('', Validators.required);
  registeredCountry = new FormControl('', Validators.required);
  registeredPincode = new FormControl('', Validators.required);
  registeredOfficePhone = new FormControl('', Validators.required);
  registeredAnnualTravelSpend = new FormControl('', Validators.required);
  websiteAddress = new FormControl('');
  IATALControl = new FormControl(0, Validators.required);
  IATANumber = new FormControl('', Validators.required);
  // servicesControl = new FormControl('', Validators.required);
  businessContactMobile = new FormControl('', Validators.required);
  businessContactEmail = new FormControl('', [Validators.required, Validators.pattern(REGEX.EMAIL)]);
  businessContactPassword = new FormControl('', Validators.required);
  businessContactConfirmPassword = new FormControl('', Validators.required);
  // panCardNumber = new FormControl('', Validators.required);
  companyDesignation = new FormControl('', Validators.required);
  nationality = new FormControl('', Validators.required);
  termsAndConditions = new FormControl('', Validators.required);
  IATAFile = new FormControl ('', Validators.required);
  GstDocumentSFile = new FormControl ('', Validators.required);
  GovtApprovedIdDocumentFile = new FormControl (null, Validators.required);

  today = new Date();
  maxDobDate = new Date(this.today.getFullYear() - 18, this.today.getMonth(), this.today.getDate());
  minDobDate = new Date(this.today.getFullYear() - 120, this.today.getMonth(), this.today.getDate());
  hide=true;
  confirmPasshide=true;
  registerType = [
    { label: 'Overseas Corporate', value: 1 },
    { label: 'Indian Corporate', value: 2 },
    { label: 'Overseas Travel Agent', value: 3 },
    { label: 'Indian Travel Agent', value: 4 },
    { label: 'Individuals', value: 5 }
  ];
  typeBusiness = [
    { label: "Sole Proprietorship", value: 1 },
    { label: "Partnership", value: 2 },
    { label: "Corporation", value: 3 },
    { label: "Govt. Organisation", value: 4 },
    { label: "Private Limited Company", value: 5 },
    { label: "Public Company", value: 6 },
    { label: "Limited Company", value: 7 },
    { label: "Exporting", value: 8 },
    { label: "Licensing", value: 9 },
    { label: "Franchising", value: 10 },
    { label: "International Business", value: 11 },
    { label: "Foreign Business", value: 12 },
    { label: "Enterprises", value: 13 },
    { label: "Global Company", value: 14 }
  ];

  govtId = [
    { label: "Aadhar Card", value: "0", disabled: false },
    { label: "PAN Card", value: "1", disabled: false },
    { label: "Passport", value: "2", disabled: true },
    { label: "Voter ID", value: "3", disabled: true },
    { label: "Driving License", value: "4", disabled: true }
  ];
  SalutationId = [
    { label: "Mr.", value: 0 },
    { label: "Ms.", value: 1 },
    { label: "Mrs.", value: 2 },
  ];
  IATAList = [
    { label: "Approved", value: 0},
    { label: "Non Approved", value: 1 },
  ]

  ServicesList = [
    { label: "Flights", value: 1, selected: false },
    { label: "Hotels", value: 2, selected: false },
    { label: "Flights + Hotels", value: 3, selected: false },
    { label: "Holiday Package", value: 4, selected: false },
    { label: "Others", value: 5, selected: false },
  ]
  
  budgetRanges = [
    { label: '1 Lakh – 5 Lakh', min: 100000, max: 500000, value: 1 },
    { label: '5 Lakh – 10 Lakh', min: 500001, max: 1000000, value: 2 },
    { label: '10 Lakh – 20 Lakh', min: 1000001, max: 2000000, value: 3 },
    { label: '20 Lakh – 30 Lakh', min: 2000001, max: 3000000, value: 4 },
    { label: '30 Lakh – 40 Lakh', min: 3000001, max: 4000000, value: 5 },
    { label: '40 Lakh – 50 Lakh', min: 4000001, max: 5000000, value: 6 },
    { label: '50 Lakh – 1 Crore', min: 5000001, max: 10000000, value: 7 },
    { label: '1 Crore +', min: 10000001, max: null, value: 8 },
  ];


  constructor(private uitlFlight: UtilityFlightService, private uitl: UtilityService, private fb: FormBuilder, private http: HttpService) { }

  ngOnInit(): void {
    this.CountryCodeList();
    this.RegisterCoporateValue();
  }

  RegisterCoporateValue() {
    this.RegisterCoporate = this.fb.group({
      registerType: this.registerTypeControl,
      typeBusinessSelect: this.typeBusinessSelect,
      govtApprovedIdSelect: this.govtApprovedIdSelect,
      govtApprovedId: this.govtApprovedId,
      vatGstCertificate: this.vatGstCertificate,
      salutationSelect: this.salutationSelect,
      firstName: this.firstName,
      middleName: this.middleName,
      lastName: this.lastName,
      dateOfBirth: this.dateOfBirth,
      aadharCardNumber: this.aadharCardNumber,
      companyName: this.companyName,
      registeredAddress: this.registeredAddress,
      registeredCity: this.registeredCity,
      registeredState: this.registeredState,
      registeredCountry: this.registeredCountry,
      registeredPincode: this.registeredPincode,
      registeredOfficePhone: this.registeredOfficePhone,
      registeredAnnualTravelSpend: this.registeredAnnualTravelSpend,
      websiteAddress: this.websiteAddress,
      IATALControl: this.IATALControl,
      IATANumber: this.IATANumber,
      servicesControl: this.fb.array([], Validators.required),
      businessContactMobile: this.businessContactMobile,
      businessContactEmail: this.businessContactEmail,
      businessContactPassword: this.businessContactPassword,
      businessContactConfirmPassword: this.businessContactConfirmPassword,
      // panCardNumber: this.panCardNumber,
      companyDesignation: this.companyDesignation,
      nationality: this.nationality,
      termsAndConditions: this.termsAndConditions,
      IATAFile: this.IATAFile,
      GstDocumentSFile: this.GstDocumentSFile,
      GovtApprovedIdDocumentFile: this.GovtApprovedIdDocumentFile
    }, { validators: CustomValidations.MatchPassword,});

  }


  CountryCodeList() {
    this.uitlFlight.fetchCountryCodeList().subscribe((data: any) => {
      this.country_APIs = data;
      this.country_APIs.sort((a: any, b: any) => {
        if (a.code === 'IN') return -1;
        if (b.code === 'IN') return 1;
        return (a.id || 0) - (b.id || 0);
      });
    });
  }
  get servicesArray(): FormArray {
    return this.RegisterCoporate.get('servicesControl') as FormArray;
  }

  onServiceChange(event: any, item: any) {
    if (event.checked) {
      this.servicesArray.push(new FormControl(item));
    } else {
      const index = this.servicesArray.controls.findIndex(
        ctrl => ctrl.value.id === item.id
      );
      this.servicesArray.removeAt(index);
    }
  }

  openFilePicker(): void {
    this.fileUpload?.nativeElement.click();
    
  }
  onFileSelected(event: Event, controlName: string): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.RegisterCoporate.get(controlName)?.setValue(file);
    }
  }

  onSubmit() {
    if (this.RegisterCoporate.invalid) {
      this.RegisterCoporate.markAllAsTouched();
      return;
    }
    this.RegisterCoporate.markAllAsTouched();
    const f = this.RegisterCoporate.value;
    const fd = new FormData();

    // fd.append('registerType', f.registerType);
    fd.append('business_type_id', f.typeBusinessSelect);
    fd.append('govtApprovedIdSelect', f.govtApprovedIdSelect);
    fd.append('client_indian_corporate_adharcard_number', f.govtApprovedId);
    fd.append('client_indian_corporate_gst_number', f.vatGstCertificate);
    fd.append('client_salute', f.salutationSelect);
    fd.append('client_fname', f.firstName);
    fd.append('client_mname', f.middleName);
    fd.append('client_lname', f.lastName);
    fd.append('client_dob', this.formatToYMD(f.dateOfBirth));
    fd.append('aadharCardNumber', f.aadharCardNumber);
    fd.append('client_company', f.companyName);
    fd.append('client_company_address', f.registeredAddress);
    fd.append('client_company_city', f.registeredCity);
    fd.append('client_company_state', f.registeredState);
    fd.append('client_company_country', f.registeredCountry);
    fd.append('client_company_pin_post_code', f.registeredPincode);
    fd.append('client_company_phone', f.registeredOfficePhone);
    fd.append('client_company_anuual_travel_spend', f.registeredAnnualTravelSpend);
    fd.append('client_company_website_address', f.websiteAddress);
    fd.append('client_iata_approval', f.IATALControl);
    fd.append('IATANumber', f.IATANumber);
    fd.append('client_business_mobile', f.businessContactMobile);
    fd.append('client_email', f.businessContactEmail);
    fd.append('client_password', f.businessContactPassword);
    fd.append('client_registred_type', f.businessContactConfirmPassword);
    fd.append('client_designation', f.companyDesignation);
    fd.append('client_nationality', f.nationality);
    fd.append('termsAndConditions', f.termsAndConditions);
    fd.append('client_iata_document', f.IATAFile);
    fd.append('client_indian_travel_agent_gst_document', f.GstDocumentSFile);
    fd.append('client_indian_travel_agent_adharcard_document', f.GovtApprovedIdDocumentFile);
    

    console.log(fd, 'fd Form');
    this.http.flightsave('apiV2/auth/b2e-signup', fd).subscribe((res) => {
      if(res.statusCode === 200) {
        this.uitl.showMsg(res.message);
      }
    })
    
  }
 
  toggleChip(item: any) {
    const index = this.servicesArray.value.indexOf(item.value);
    if (index === -1) {
      this.servicesArray.push(this.fb.control(item.value));
    } else {
      this.servicesArray.removeAt(index);
    }
    this.servicesArray.markAsTouched();
  }

  onIATAFileSelect(file: File) {
    const control = this.RegisterCoporate.get('IATAFile');
    control?.setValue(file);
    control?.markAsTouched();
  }

  onVatGstDocumentSelected(file: File) {
    const control = this.RegisterCoporate.get('GstDocumentSFile');
    control?.setValue(file);
    control?.markAsTouched();
  }

  onGovtApprovedIdDocumentSelected(file: File) {
    const control = this.RegisterCoporate.get('GovtApprovedIdDocumentFile');
    control?.setValue(file);
    control?.markAsTouched();
  }

  formatToYMD(date: any): string {
    if (!date) return '';
    const d = date instanceof Date ? date : new Date(date);
    if (isNaN(d.getTime())) return ''; // Invalid date safe guard
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}
